// composables/useAgentTimeout.js
import { ref, onBeforeUnmount } from 'vue'

export function useAgentTimeout(timeoutDuration = 120000) {
  const agentTimeoutTimer = ref(null);
  const showAgentTimeout = ref(false);

  const startAgentTimeoutTimer = () => {
    console.log('⏰ Starting agent timeout timer (2 minutes)');
    
    clearAgentTimeoutTimer(); // Clear any existing timer
    
    agentTimeoutTimer.value = setTimeout(() => {
      console.log('⏰ Agent timeout reached - showing options');
      showAgentTimeout.value = true;
    }, timeoutDuration);
  };

  const clearAgentTimeoutTimer = () => {
    if (agentTimeoutTimer.value) {
      console.log('⏰ Clearing agent timeout timer');
      clearTimeout(agentTimeoutTimer.value);
      agentTimeoutTimer.value = null;
    }
  };

  const handleContinueWaiting = () => {
    console.log('👀 Customer chose to continue waiting');
    showAgentTimeout.value = false;
    startAgentTimeoutTimer(); // Restart timer
  };

  const handleTimeoutResolved = () => {
    console.log('✅ Timeout resolved');
    showAgentTimeout.value = false;
    clearAgentTimeoutTimer();
  };

  // Cleanup on component unmount
  onBeforeUnmount(() => {
    clearAgentTimeoutTimer();
  });

  return {
    showAgentTimeout,
    startAgentTimeoutTimer,
    clearAgentTimeoutTimer,
    handleContinueWaiting,
    handleTimeoutResolved
  };
}